import TemplateView from '../../../TemplateView'
import messageResource from '../../../messageResource'
import {CURRENT_PRODUCT, Product, PRODUCTS_INTEGRATED} from '../../../constants'

export default class LastManagerInfo extends TemplateView {
    constructor({
        isDeleting = false,
        product = CURRENT_PRODUCT,
    } = {}) {
        super()

        this.params = {
            isDeleting,
            product
        }

        this.state = {
            userName: '',
        }

        this.onStatePropertyChanged('userName', (userName) => {
            this.$title.text(this.params.isDeleting
                             ? messageResource.getMessage('user.last_manager.delete.title', [userName])
                             : messageResource.getMessage('user.last_manager.disable.title',
                    [PRODUCTS_INTEGRATED ? this.params.product : CURRENT_PRODUCT, userName])
            )

            const productNames = PRODUCTS_INTEGRATED ? `${Product.actiTIME} & ${Product.actiPLANS}` : CURRENT_PRODUCT
            this.$description.text(this.params.isDeleting
                                   ? messageResource.getMessage('user.last_manager.delete.description', [userName, productNames])
                                   : messageResource.getMessage('user.last_manager.disable.description', [userName, productNames])
            )
        })
    }

    templateHtml() {
        return '<div class="lastManagerInfo">' +
               '    <div class="title"/>' +
               '    <div class="description"/>' +
               '    <div class="note">' +
               '        <div class="icon"/>' +
               '        <div class="text"><%=note%></div>' +
               '    </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            note: 'user.last_manager.note',
        }
    }

    afterRender() {
        this.$title = this.find('.title')
        this.$description = this.find('.description')
        this.renderInitialState()
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/user/editPanel/LastManagerInfo.js